export const ALLOWED_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/zip',
  'text/plain',
  'text/html',
  'video/mpeg',
  'video/mp4',
  'image/png',
  'image/jpeg',
  'image/jpeg',
  // the options below may get removed depending on PM feedback
  'audio/mpeg',
  'video/mpeg',
  'image/gif',
  'video/webm',
  'image/webp',
];

/** Max total attachment size for chat (50MB). No per-file limit. */
export const CHAT_MAX_TOTAL_ATTACHMENT_BYTES = 50 * 1024 * 1024;
export const MAX_TOTAL_SIZE = CHAT_MAX_TOTAL_ATTACHMENT_BYTES;
/** Same as max total so a single file up to 50MB is allowed (no per-file cap). */
export const MAX_FILE_SIZE = CHAT_MAX_TOTAL_ATTACHMENT_BYTES;
